/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconAddLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 12 12">
    <><rect x="5" width="2" height="12" />
<rect y="5" width="12" height="2" /></>
  </Icon>
);
};

IconAddLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEyIDEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMiAxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmVjdCB4PSI1IiB3aWR0aD0iMiIgaGVpZ2h0PSIxMiIvPgo8cmVjdCB5PSI1IiB3aWR0aD0iMTIiIGhlaWdodD0iMiIvPgo8L3N2Zz4=";
IconAddLineComponent.Content = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 12" style="enable-background:new 0 0 12 12;" xml:space="preserve">
<rect x="5" width="2" height="12"/>
<rect y="5" width="12" height="2"/>
</svg>`;

const IconAddLine = styled(IconAddLineComponent)``;

export default IconAddLine;
